import React from "react";
import styled from "@emotion/styled";
import { Input } from "antd";

interface StockDropdownProps {
  minValue: string;
  maxValue: string;
  setMinValue: React.Dispatch<React.SetStateAction<string>>;
  setMaxValue: React.Dispatch<React.SetStateAction<string>>;
}

const StockDropdown: React.FC<StockDropdownProps> = ({
  minValue,
  maxValue,
  setMinValue,
  setMaxValue,
}) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: "min" | "max",
  ) => {
    const raw = e.target.value;
    const onlyNumbers = raw.replace(/[^0-9]/g, ""); // 숫자만 남김

    if (type === "min") setMinValue(onlyNumbers);
    else setMaxValue(onlyNumbers);
  };

  return (
    <Container>
      <StyledInput
        value={minValue}
        onChange={(e) => handleChange(e, "min")}
        placeholder="최소 수량"
      />
      ~
      <StyledInput
        value={maxValue}
        onChange={(e) => handleChange(e, "max")}
        placeholder="최대 수량"
      />
    </Container>
  );
};

export default StockDropdown;

const Container = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "1rem",
  marginTop: "1rem",
});

const StyledInput = styled(Input)(({ theme }) => ({
  width: "100%",
  height: "5.2rem",
  padding: "1rem 1.5rem",
  borderRadius: "10px",
  border: `1px solid ${theme.color.light_gray}`,
}));
